<template>
    <div
        class="image-wrapper"
        :class="{'gradient-wrapper': withGradient}">
        <responsive-image
            :class="imageClasses"
            :image="{ srcset:srcset, url:src, width:width }"
            :fallback-image="fallbackImage"
            :alt="alt"
        />
        <div
            v-if="withGradient"
            class="gradient-overlay" />
    </div>
</template>

<script>
import ResponsiveImage from '@web/components/ResponsiveImage';

export default {
  name: 'WrappedImage',
  components: {
    ResponsiveImage,
  },
  props: {
    srcset: {
      default:
                    '/img/web/services-slide-bg-480.jpg 480w, '
                    + '/img/web/services-slide-bg-1024.jpg 1024w, '
                    + '/img/web/services-slide-bg-1920.jpg 1920w, '
                    + '/img/web/services-slide-bg-3440.jpg 3440w',
    },
    sizes: {
      type: String,
      required: false,
      default: '',
    },
    src: {
      type: String,
      required: true,
      default: '/img/web/services-slide-bg-1024.jpg',
    },
    fallbackImage: {
      type: String,
      required: false,
      default: '',
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
    imageClasses: {
      type: String,
      required: false,
      default: '',
    },
    width: {
      type: Number,
      required: false,
      default: null,
    },
    withGradient: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>

<style scoped lang="scss">
    .gradient-overlay {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(180deg, rgba(21, 21, 22, 0.00) 0%, #151516 100%);

        @media screen and (min-width: 1280px) {
            background: linear-gradient(180deg, rgba(21, 21, 22, 0.00) 50%, #151516 100%);
        }
    }

    .gradient-wrapper {
        background: linear-gradient(180deg, rgba(21, 21, 22, 0.00) 34%, #434D57 100%);
    }
</style>
